'use strict'

// object 초기화
const initObject = function (object, deep) {
  let self = this;
  self.obj = object;

  for (var key in object) {
    switch (typeof object[key]) {
      case 'number':          // 정수
        self.obj[key] = 0;
        break;
      case 'boolean':         // boolean
        self.obj[key] = false;
        break;
      case 'array':           // array
        self.obj[key] = [];
        break;
      case 'array':           // array
        self.obj[key] = [];
        break;
      case 'object':          // object
        if (deep) {
          initObject(self.obj[key]);
        } else {
          self.obj[key] = {};
        }
        break;
      default:                // 문자
        self.obj[key] = '';
    }
  }
}

// 숫자 3자리 콤마
const numberComma = function(value) {
	var len, point, str;

	if (value) {
	  value = value.toString(); // 문자열로 변환
	  let [integerPart, decimalPart] = value.split('.'); // 정수부와 소수부 분리
	  point = integerPart.length % 3;
	  len = integerPart.length;

	  str = integerPart.substring(0, point);
	  while (point < len) {
		if (str !== "") str += ",";
		str += integerPart.substring(point, point + 3);
		point += 3;
	  }

	  // 소수부가 존재할 경우 추가
	  if (decimalPart) {
		str += '.' + decimalPart;
	  }
	} else {
	  str = value;
	}

	return str;
  }

// 오늘 날짜 yyyy-MM-dd
const getToday = function () {
  var d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

// 오늘 날짜 yyyy-MM
const getThisMonth = function () {
  var d = new Date(),
    month = '' + (d.getMonth() + 1),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;

  return [year, month].join('-');
}

// 오늘 월의 1일 yyyy-MM-dd
const getFirstDay = function () {
  var d = new Date();

  var month = '' + (d.getMonth() + 1);
  var day = '01';
  var year = d.getFullYear();

  if (month.length < 2) month = '0' + month;

  return [year, month, day].join('-');
}

// 오늘 부 -month 월 전 날짜 yyyy-MM-dd
const getDate = function (month) {
  var d = new Date();
  var monthOfYear = d.getMonth();
  d.setMonth(monthOfYear - month);

  var month = '' + (d.getMonth() + 1);
  var day = '' + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

// trgtDate : 지정 날짜(yyyyMMdd 또는 yyyy-MM-dd)에서
// plusDay : 지정일 계산한 날짜를
// return : yyyy-MM-dd 형태로 리턴
// 합당하지 않은 파람시 '' 리턴
const getAddDay = function (trgtDate, plusDay) {
  if (trgtDate == null) return "";
  if (trgtDate.indexOf('-') > -1) {
    var regexp = /[^0-9]/g
    trgtDate = trgtDate.replace(regexp, '');
  }
  if (trgtDate.length != 8) return "";
  var newDate = new Date();
  var trgtDateTime = new Date(trgtDate.substr(0, 4), trgtDate.substr(4, 2) - 1, trgtDate.substr(6, 2)).getTime();

  var processTime = trgtDateTime + (parseInt(plusDay) * 24 * 60 * 60 * 1000);
  newDate.setTime(processTime);

  var year = newDate.getFullYear();
  var month = newDate.getMonth() + 1;
  var day = newDate.getDate();

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  return [year, month, day].join('-');
}

// aDate : 날짜(yyyyMMdd 또는 yyyy-MM-dd)에서
// bDate : 날짜(yyyyMMdd 또는 yyyy-MM-dd)를 뺀 결과를
// return : ms(밀리초 : day * 24 * 60 * 60 * 1000)로 리턴
// 합당하지 않은 파람시 -1 리턴
// ex) '2019-09-09' - '2019-08-09' = 2678400000 (31일)
// ex) '2019-08-09' - '2019-09-09' = -2678400000 (-31일)
const getDiffDate = function (aDate, bDate) {
  if (aDate == null || bDate == null) return -1;
  if (aDate.indexOf('-') > -1) {
    var regexp = /[^0-9]/g
    aDate = aDate.replace(regexp, '');
  }
  if (bDate.indexOf('-') > -1) {
    var regexp = /[^0-9]/g
    bDate = bDate.replace(regexp, '');
  }
  if (aDate.length != 8 || bDate.length != 8) return -1;

  var aDateTime = new Date(aDate.substr(0, 4), aDate.substr(4, 2) - 1, aDate.substr(6, 2)).getTime();
  var bDateTime = new Date(bDate.substr(0, 4), bDate.substr(4, 2) - 1, bDate.substr(6, 2)).getTime();

  var result = aDateTime - bDateTime;

  return result;
}

const showLoading = function (name) {
  var html = '<div id="loading" name="loading" class="' + name + '"><div class="car"></div></div>';
  $('body').append(html)
  $('.' + name).show();
}

const hideLoading = function (name) {
  $('.' + name).hide();
  $('.' + name).remove();
}

var isEmpty = function(value){
	if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
		return true
	}else{
		return false
	}
}

var renderDate = function(val){
	const [date, time] = val.split(' ');
	const [hours, minutes, seconds] = time.split(':');
	const [sec, ms] = seconds.split('.');
	const formattedTime = `${hours}:${minutes}`;
	return `${date}`;
}

var renderDatetime = function(val){
	const [date, time] = val.split(' ');
	const [hours, minutes, seconds] = time.split(':');
	const [sec, ms] = seconds.split('.');
	const formattedTime = `${hours}:${minutes}`;
	return `${date} ${formattedTime}`;
}


export default {
  initObject,
  numberComma,
  getToday,
  getThisMonth,
  getDate,
  getAddDay,
  getDiffDate,
  showLoading,
  hideLoading,
  isEmpty,
  renderDate,
  renderDatetime
}


// WEBPACK FOOTER //
// ./src/modules/utils.js